/*رستوران*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={90.83}
      height={90.83}
      viewBox="0 0 90.83 90.83"
      {...props}
    >
      <path
        data-name="Rectangle 654"
        fill="#ececec"
        d="M10.035 47.944h70.244v41.255H10.035z"
      />
      <path
        data-name="Rectangle 655"
        fill="#b6c1ce"
        d="M10.035 84.739h70.244v4.46H10.035z"
      />
      <path
        data-name="Path 7558"
        d="M76.18 16.115H14.65l-8.79 26.37v4.395a4.4 4.4 0 108.79 0 4.4 4.4 0 108.79 0 4.395 4.395 0 108.79 0 4.4 4.4 0 108.79 0 4.4 4.4 0 108.79 0 4.4 4.4 0 108.79 0 4.395 4.395 0 108.79 0 4.4 4.4 0 108.79 0 4.4 4.4 0 108.79 0v-4.395z"
        fill="#fb5968"
      />
      <path
        data-name="Path 7559"
        d="M10.26 51.275a4.395 4.395 0 004.395-4.4 4.4 4.4 0 108.79 0 4.395 4.395 0 108.79 0 4.4 4.4 0 108.79 0 4.4 4.4 0 108.79 0 4.4 4.4 0 108.79 0 4.395 4.395 0 108.79 0 4.4 4.4 0 108.79 0 4.4 4.4 0 108.79 0v-4.39H5.86v4.395a4.395 4.395 0 004.4 4.395z"
        fill="#cd2c5a"
      />
      <ellipse
        data-name="Ellipse 356"
        cx={17.282}
        cy={17.84}
        rx={17.282}
        ry={17.84}
        transform="translate(27.875 1.115)"
        fill="#ffeaa7"
      />
      <g data-name="Group 350" fill="#92e0c0">
        <path
          data-name="Path 7560"
          d="M23.44 77.65c-.089 0-.173.021-.261.026a4.381 4.381 0 00-4.134-2.956 4.337 4.337 0 00-1.03.135 4.339 4.339 0 00-6.73 0 4.337 4.337 0 00-1.03-.135 4.381 4.381 0 00-4.134 2.956c-.088-.006-.171-.026-.261-.026a4.395 4.395 0 00-4.395 4.39v7.325h26.37V82.04a4.395 4.395 0 00-4.395-4.39z"
        />
        <path
          data-name="Path 7561"
          d="M84.97 77.65c-.089 0-.173.021-.261.026a4.381 4.381 0 00-4.134-2.956 4.336 4.336 0 00-1.03.135 4.339 4.339 0 00-6.73 0 4.312 4.312 0 00-5.164 2.822c-.088-.006-.171-.026-.261-.026a4.395 4.395 0 00-4.4 4.395v7.325h26.37V82.04a4.395 4.395 0 00-4.39-4.39z"
        />
      </g>
      <g data-name="Group 351" fill="#d3a06c">
        <path data-name="Rectangle 656" d="M62.438 83.625h26.76V89.2h-26.76z" />
        <path data-name="Rectangle 657" d="M1.114 83.625h26.76V89.2H1.114z" />
      </g>
      <path
        data-name="Rectangle 658"
        fill="#eabd8c"
        d="M33.45 56.864h23.415v32.335H33.45z"
      />
      <path
        data-name="Rectangle 659"
        fill="#d3a06c"
        d="M33.45 84.739h23.415v4.46H33.45z"
      />
      <g data-name="Group 352" fill="#39c3fc">
        <path data-name="Rectangle 660" d="M17.839 59.094h8.92v7.805h-8.92z" />
        <path data-name="Rectangle 661" d="M64.668 59.094h8.92v7.805h-8.92z" />
      </g>
      <path
        data-name="Path 7562"
        d="M85.653 76.22a5.808 5.808 0 00-3.613-2.782V52.532a5.854 5.854 0 004.4-5.652v-4.632l-9.2-27.6H63.928a19.023 19.023 0 00-37.026 0H13.594l-9.2 27.6v4.632a5.854 5.854 0 004.4 5.652v20.906a5.8 5.8 0 00-3.617 2.782A5.869 5.869 0 000 82.04v8.79h90.83v-8.79a5.869 5.869 0 00-5.177-5.82zm-2.328 1.934l.36 1.034 1.094-.053a.888.888 0 00.19-.025 2.933 2.933 0 012.93 2.93H64.46a2.922 2.922 0 012.874-2.93l1.339.078.36-1.034a2.926 2.926 0 012.751-1.973 3.006 3.006 0 01.686.092l.888.214.583-.7a2.963 2.963 0 014.477 0l.583.7.888-.214a3.006 3.006 0 01.686-.092 2.923 2.923 0 012.75 1.972zm-2.75-28.344a2.933 2.933 0 01-2.93-2.93v-2.93h5.86v2.93a2.933 2.933 0 01-2.93 2.93zM38.09 20.51a2.933 2.933 0 01-2.93-2.93c0-2.19 1.834-5.86 2.93-5.86s2.93 3.67 2.93 5.86a2.933 2.933 0 01-2.93 2.93zm1.754 16.745l-.209 3.765h-5.769l.7-6.339a19 19 0 005.278 2.574zm16.415-2.574l.7 6.339H51.2l-.209-3.765a19 19 0 005.268-2.574zm12.372 6.339l-3.907-23.44h4.421l5.21 23.44zm-2.97 0h-5.75l-.955-8.6a19.1 19.1 0 004.193-6.477zm-17.574-3.139l.174 3.139h-5.692l.174-3.139a17.147 17.147 0 005.344 0zM30.919 41.02h-5.75l2.512-15.078a19.09 19.09 0 004.193 6.477zm-8.72 0h-5.724l5.21-23.44h4.421zm-6.084 2.93h5.86v2.93a2.93 2.93 0 01-5.86 0zm8.79 0h5.86v2.93a2.93 2.93 0 01-5.86 0zm8.79 0h5.86v2.93a2.93 2.93 0 01-5.86 0zm8.79 0h5.86v2.93a2.93 2.93 0 01-5.86 0zm8.79 0h5.86v2.93a2.93 2.93 0 01-5.86 0zm8.79 0h5.86v2.93a2.93 2.93 0 01-5.86 0zm8.79 0h5.86v2.93a2.93 2.93 0 01-5.86 0zm14.083-2.93h-5.583l-5.21-23.44h2.978zM45.415 2.93a16.1 16.1 0 018.79 29.6v-9.3a5.854 5.854 0 004.4-5.652v-7.323H55.67v7.325a2.92 2.92 0 01-1.465 2.52v-9.845h-2.93V20.1a2.92 2.92 0 01-1.465-2.52v-7.325h-2.93v7.325a5.854 5.854 0 004.4 5.652v10.809a15.9 15.9 0 01-11.72 0V23.232a5.854 5.854 0 004.4-5.652c0-3.019-2.282-8.79-5.86-8.79s-5.86 5.771-5.86 8.79a5.854 5.854 0 004.4 5.652v9.3a16.1 16.1 0 018.79-29.6zM15.706 17.58h2.978l-5.21 23.44H7.892zm-8.381 29.3v-2.93h5.86v2.93a2.93 2.93 0 01-5.86 0zM5.8 79.11l1.339.078.36-1.034a2.926 2.926 0 012.751-1.973 3.006 3.006 0 01.686.092l.888.214.583-.7a2.963 2.963 0 014.477 0l.583.7.888-.214a3.006 3.006 0 01.686-.092 2.923 2.923 0 012.75 1.973l.36 1.034 1.094-.053a.888.888 0 00.19-.025 2.933 2.933 0 012.93 2.93H2.93a2.922 2.922 0 012.87-2.93zM2.93 87.9v-2.93h23.44v2.93zm52.74 0H35.16V58.6h20.51zm5.86 0H58.6V55.67H32.23V87.9H29.3v-5.86a5.869 5.869 0 00-5.177-5.82 5.756 5.756 0 00-5.595-2.945 5.988 5.988 0 00-6.808-.67v-20.07a5.862 5.862 0 002.93-1.784 5.851 5.851 0 008.79 0 5.852 5.852 0 008.79 0 5.852 5.852 0 008.79 0 5.852 5.852 0 008.79 0 5.852 5.852 0 008.79 0 5.852 5.852 0 008.79 0 5.852 5.852 0 008.79 0 5.852 5.852 0 002.93 1.784v20.072a5.983 5.983 0 00-6.808.67 5.755 5.755 0 00-5.595 2.945 5.866 5.866 0 00-5.177 5.818zm2.93 0v-2.93H87.9v2.93z"
      />
      <path data-name="Rectangle 662" d="M37.91 71.359h3.345v3.345H37.91z" />
      <path
        data-name="Path 7563"
        d="M16.115 68.855h11.72v-11.72h-11.72zm2.93-8.79h5.86v5.86h-5.86z"
      />
      <path
        data-name="Path 7564"
        d="M74.715 57.135h-11.72v11.72h11.72zm-2.93 8.79h-5.86v-5.86h5.86z"
      />
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
